import {
    FAILURE,
    LIST,
    REQUEST,
    SUCCESS
} from '../../../../redux/ActionType';
import { JOB_APPLICATIONS_BY_TECHNOLOGY } from '../../constants';

const initialState = {
    list: [],
    count: 0,
    loading: false,
    error: undefined
};

export const favoriteJobApplications = (state = initialState, action) => {
    const { payload } = action;
    switch (action.type) {
        case REQUEST(LIST(JOB_APPLICATIONS_BY_TECHNOLOGY)):
            return {
                ...state,
                loading: true,
                error: undefined
            };

        case SUCCESS(LIST(JOB_APPLICATIONS_BY_TECHNOLOGY)):
            return {
                ...state,
                loading: false,
                error: undefined,
                ...payload
            };

        case FAILURE(LIST(JOB_APPLICATIONS_BY_TECHNOLOGY)):
            return {
                ...state,
                loading: false,
                error: payload
            };

        default:
            return state;
    }
};
